import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import CompanyListDropDown from "../components/CompanyListDropDown";
import { useGetDesignIndexFieldList } from "../application/Hooks/useGetDesignIndexFieldList";
import { UploadInfo } from "../domain/entities/UploadInfo";
import { useUploadFile } from "../application/Hooks/useUploadFile";
import { useNavigate } from "react-router-dom";
import CustomAlertV2 from "../components/CustomAlertV2";
import useGetCompanyStatus from "../application/Hooks/useGetCompanyStatus";
import { useOidcUser } from "@axa-fr/react-oidc";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, parse } from "date-fns"; // You'll need to install date-fns
import RoleBasedSecure from "../components/RoleBasedSecure";

const Upload = () => {
  const { oidcUser } = useOidcUser();
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const { companyId } = location.state || {};
  const [selectedCompanyIdValue, setSelectedCompanyIdValue] = useState(0);
  const [uploadData, setUploadData] = useState({
    totalpage: 0,
    documenttype: "",
    filedata: null,
  });
  const [indexFields, setIndexFields] = useState([]);
  const [successMessage, setSuccessMessage] = useState(null);
  const { designIndexFieldList } = useGetDesignIndexFieldList(
    selectedCompanyIdValue
  );
  const { uplaodResponse, uploadFile } = useUploadFile();
  const navigate = useNavigate();
  const [isDisabled, setisDisabled] = useState(false);
  const { APICompanyStatus } = useGetCompanyStatus(selectedCompanyIdValue);
  const [inputs, setInputs] = useState({});

  useEffect(() => {
    if (APICompanyStatus) {
      setisDisabled(APICompanyStatus === "Deactivated");
    }
  }, [APICompanyStatus]);

  useEffect(() => {
    const fetchData = () => {
      debugger;
      if (
        designIndexFieldList &&
        designIndexFieldList.indexFields &&
        designIndexFieldList.indexFields.length > 0
      ) {
        setSelectedCompanyIdValue(designIndexFieldList.companyid);
        const formattedFields = designIndexFieldList.indexFields.map(
          (field) => ({
            columnName: field.columnName,
            columnDataType: field.columnDataType,
            columnLength: field.columnLength,
            defaultValue: field.defaultValue,
            isRequired: field.isRequired,
          })
        );
        setIndexFields(formattedFields);
      }
    };
    // Call fetchData inside useEffect
    fetchData();
  }, [designIndexFieldList]);

  // useEffect(() => {
  //   if (designIndexFieldList?.indexFields?.length > 0) {
  //     setSelectedCompanyIdValue(designIndexFieldList.companyid);
  //     setIndexFields(
  //       designIndexFieldList.indexFields.map((field) => ({
  //         columnName: field.columnName,
  //         columnDataType: field.columnDataType,
  //         columnLength: field.columnLength,
  //         defaultValue: field.defaultValue,
  //         isRequired: field.isRequired,
  //       }))
  //     );
  //   }
  // }, [designIndexFieldList]);

  const handleInputChange = useCallback((event, index) => {
    setInputs((prev) => ({ ...prev, [index]: event.target.value }));
  }, []);

  const handleDateInputChange = (event, fieldName) => {
    const value = event.target.value;
    setInputs((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const handleUploadFile = useCallback((e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "image/jpeg",
      "image/tiff",
      "text/plain",
      "image/bmp",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ];
    const maxSize = 35 * 1024 * 1024;

    if (!allowedTypes.includes(file.type)) {
      alert("Invalid file type. Only JPEG, JPG, PNG, and PDF are allowed.");
      e.target.value = "";
    } else if (file.size > maxSize) {
      alert("File size greater than 35 MB.");
      e.target.value = "";
    } else {
      setUploadData((prev) => ({ ...prev, filedata: file }));
    }
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      const uploadRequest = new UploadInfo(
        selectedCompanyIdValue,
        JSON.stringify(inputs),
        uploadData.totalpage ?? 0,
        uploadData.documenttype ?? "",
        uploadData.filedata
      );
      await uploadFile(uploadRequest);
      setSuccessMessage("File submitted successfully!");
    } catch (error) {
      console.error("Error saving data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const handleDropdownChange = (value) => {
    console.log("dropdown change value " + value);
    setSelectedCompanyIdValue(value);
  };

  const handleConfirm = () => {
    setSuccessMessage(null); // Hide the success message
    setSelectedCompanyIdValue(0); // Reset dropdown to default (Assuming 0 means "Please select")
    setUploadData({
      totalpage: 0,
      documenttype: "",
      filedata: null,
    }); // Clear upload-related data
    setInputs({}); // Reset dynamic input fields
    setIndexFields([]); // Clear index fields
    setTimeout(() => {
      setSelectedCompanyIdValue(0); // Ensure the dropdown resets properly
    }, 0);
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="page_wrp">
            <div className="page_title">Upload File</div>
            <form onSubmit={handleSubmit}>
              <div className="contant_box_wrp">
                <div className="manageCompanyWrp">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="Select_Company">
                        <RoleBasedSecure roles={["SuperAdmin"]}>
                          <CompanyListDropDown
                            value={selectedCompanyIdValue}
                            onChange={handleDropdownChange}
                          />
                        </RoleBasedSecure>
                      </div>
                    </div>
                  </div>
                  <hr />
                </div>
                <div className="row">
                  <div className="col-md-9 bold">
                    <div className="row">

                    </div>
                    {selectedCompanyIdValue > 0 && (
                      <div className="row">

                        {selectedCompanyIdValue > 0 &&
                          indexFields.map((field, index) => (
                            <div key={index} className="col-md-4 mb-3">
                              <label>
                                {field.columnName}{" "}
                                {field.isRequired && (
                                  <span style={{ color: "red" }}>*</span>
                                )}
                              </label>
                              {field.columnDataType === "Date" ? (
                                <DatePicker
                                  selected={
                                    inputs[field.columnName] || field.defaultValue
                                      ? parse(
                                        inputs[field.columnName] ||
                                        field.defaultValue,
                                        "yyyy-MM-dd",
                                        new Date()
                                      )
                                      : null
                                  }
                                  onChange={(date) => {
                                    // Convert Date to yyyy-MM-dd format before saving
                                    const formattedDate = date
                                      ? format(date, "yyyy-MM-dd")
                                      : "";
                                    handleDateInputChange(
                                      {
                                        target: {
                                          name: field.columnName,
                                          value: formattedDate,
                                        },
                                      },
                                      field.columnName
                                    );
                                  }}
                                  dateFormat="MM-dd-yyyy"
                                  className="form-control"
                                  placeholderText="MM-DD-YYYY"
                                  required={field.isRequired}
                                  disabled={isDisabled}
                                />
                              ) : (
                                <input
                                  type={
                                    field.columnDataType === "Number"
                                      ? "number"
                                      : "text"
                                  }
                                  className="form-control"
                                  value={
                                    inputs[field.columnName] || field.defaultValue
                                  }
                                  maxLength={field.columnLength}
                                  onChange={(e) =>
                                    handleInputChange(e, field.columnName)
                                  }
                                  required={field.isRequired}
                                  disabled={isDisabled}
                                />
                              )}
                            </div>
                          ))}
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Total Page</label>
                            <input
                              type="number"
                              className="form-control"
                              value={uploadData.totalpage}
                              onChange={(e) =>
                                setUploadData((prev) => ({
                                  ...prev,
                                  totalpage: e.target.value,
                                }))
                              }
                              required
                              disabled={isDisabled}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label>Document Type</label>
                            <input
                              type="text"
                              className="form-control"
                              minLength={2}
                              maxLength={100}
                              value={uploadData.documenttype}
                              onChange={(e) =>
                                setUploadData((prev) => ({
                                  ...prev,
                                  documenttype: e.target.value,
                                }))
                              }
                              disabled={isDisabled}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    {selectedCompanyIdValue > 0 && (
                      <div className="form-group mt-3">
                        <label>Select file</label>
                        <input
                          type="file"
                          className="form-control"
                          onChange={handleUploadFile}
                          accept=".jpg,.png,.jpeg,.pdf,.tif,.tiff,.bmp,.doc,.docx,.txt,.pptx"
                          required
                          disabled={isDisabled}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {!isDisabled && selectedCompanyIdValue > 0 && (
                <button
                  type="submit"
                  className="btn nextBtn"
                  disabled={isLoading}
                >
                  {isLoading ? "Submitting..." : "Submit"}
                </button>
              )}
            </form>
          </div>
        </div>
        {successMessage && (
          <CustomAlertV2
            message={successMessage}
            onClose={handleConfirm}
            onConfirm={handleConfirm}
            isCancelButton={false}
          />
        )}
      </div>
    </div>
  );
};

export default Upload;
